<template>
  <div>
    <spinner v-if="activateSpinner"></spinner>
    <div v-else>
      <b-row>
        <b-col sm="6" class="form-group" v-if="isEditable">
          <form-write-group-label-input v-model="name"
          :inputLabel="$t('common.security.ca_name')">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group" v-else>
          <form-read-group-label-input
          :inputLabel="$t('common.security.ca_name')"
          :inputValue="name">
          </form-read-group-label-input>
        </b-col>
      </b-row>
      <b-row class="d-flex" :key="refreshTab">
        <b-col sm="5" class="form-group" v-if="isEditable">
          <label>
            {{ $t('common.security.cert_not_present') }}
          </label>
          <b-table
          thead-class="d-none"
          :items="listCertificateOutGroup"
          :fields="fields"
          hover
          select-mode="multi" :selectable="listCertificateOutGroup.length > 0"
          empty-text="Pas de résultat"
          @row-selected="onRowSelectedOutGroup">
            <template #cell(name)="data">
              <span>{{ data.value }}</span>
            </template>
          </b-table>
          <!--ANCIENNE TABLE DRO : 30/06/2023
          <table relative class="table b-table table-hover" :class="listCertificateOutGroup.length ? 'b-table-selectable b-table-select-single' : ''">
            <tbody role="rowgroup" v-if="listCertificateOutGroup.length">
              <tr role="row" v-for="(certificate, index) in listCertificateOutGroup" :key="'certificate-'+index" @click="selectCertificate(certificate)" :class="{'text-light bg-secondary' : certificate.selected}">
                <td role="cell" class="text-center">{{certificate.name}}</td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr role="row" class="no-hover">
                <td role="cell" colspan="3" class="text-center font-weight-bold">
                  Pas de résultat
                </td>
              </tr>
            </tbody>
          </table>
          -->
        </b-col>
        <b-col cols="1" class="align-self-top mt-4 pt-1" v-if="isEditable">
          <b-button class="back-button" @click="putCertificateRight()">
            <i class="fa-solid fa-chevron-right"></i>
          </b-button>
          <b-button class="back-button mt-3" @click="putCertificateLeft()">
            <i class="fa-solid fa-chevron-left"></i>
          </b-button>
          <b-button class="back-button mt-3" @click="putAllCertificate(true)">
            <i class="fa-solid fa-angles-right"></i>
          </b-button>
          <b-button class="back-button mt-3" @click="putAllCertificate(false)">
            <i class="fa-solid fa-angles-left"></i>
          </b-button>
        </b-col>
        <b-col sm="5" class="form-group align-items-start">
          <label>
            {{ $t('common.security.cert_present') }}
          </label>
          <b-table
          thead-class="d-none"
          :items="listCertificateInGroup"
          :fields="fields"
          hover
          select-mode="multi" :selectable="listCertificateInGroup.length > 0"
          empty-text="Pas de résultat"
          @row-selected="onRowSelectedInGroup">
            <template #cell(name)="data">
              <span>{{ data.value }}</span>
            </template>
          </b-table>
          <!--ANCIENNE TABLE DRO : 30/06/2023
          <table relative class="table b-table table-hover" :class="listCertificateInGroup.length && isEditable ? 'b-table-selectable b-table-select-single' : ''">
            <tbody role="rowgroup" v-if="listCertificateInGroup.length">
              <tr role="row" v-for="(certificate, index) in listCertificateInGroup" :key="'certificate-'+index" @click="selectCertificate(certificate)" :class="{'text-light  bg-secondary' : certificate.selected}">
                <td role="cell" class="text-center">{{certificate.name}}</td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr role="row" class="no-hover">
                <td role="cell" colspan="3" class="text-center font-weight-bold">
                  Pas de certification...
                </td>
              </tr>
            </tbody>
          </table>
          -->
        </b-col>
      </b-row>
      <b-row class="justify-content-end no-gutter">
        <b-button variant="primary" v-if="isEditable && formType !== 'add'"
          class="mx-3"
          @click="switchMode('view')">
          <span>{{ $t('common.cncl') }}</span>
        </b-button>
        <b-button variant="primary" v-if="!isEditable && formType !== 'add'"
          class="mx-3"
          @click="switchMode('edit')">
          <span>{{ $t('administration.edit') }}</span>
        </b-button>
        <b-button variant="primary" v-if="!isEditable && formType !== 'add'"
          class="mx-3"
          @click="deleteCA">
          <i class="fa-light fa-trash"></i>
          <span>{{ $t('rights.delete') }}</span>
        </b-button>
        <b-button variant="primary" v-if="isEditable && formType !== 'add'"
          class="mx-3"
          @click="editCA">
          <i class="fa-light fa-save"></i>
          <span>{{$t('common.sve')}}</span>
        </b-button>
        <b-button variant="primary" v-if="mode === 'add'"
          class="mx-3"
          @click="createCA">
          <i class="fa-light fa-save"></i>
          <span>{{$t('common.sve')}}</span>
        </b-button>
      </b-row>
    </div>
  </div>
</template>
<script>

import _ from 'lodash'
import Spinner from '@/components/common/spinner.vue'
import backButton from "@/components/common/backButton.vue"
import FormAccordion from '@/components/common/FormAccordion.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'CAFormGlobal',
  components: {
    'back-button': backButton,
    'form-accordion': FormAccordion,
    'form-read-group-label-input': formReadGroupLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'spinner': Spinner

  },
  props: {
    mode: {
      type: String,
      default: 'add'
    },
    id: {
      type: String,
      default: '-1'
    }
  },
  computed: {
    isEditable () {
      return this.formType === 'add' || this.formType === 'edit'
    },
    listCertificateOutGroup () {
      return this.listCertificates.filter(elem => {
        return !elem.inGroup
      })
    },
    listCertificateInGroup () {
      return this.listCertificates.filter(elem => {
        return elem.inGroup
      })
    }
  },
  data: () => {
    return {
      activateSpinner: true,
      currentCA: {},
      fields: [],
      formType: 'add',
      name: '',
      pageTitle: '',
      listCertificates: [],
      refreshTab: false
    }
  },
  created () {
    this.activateSpinner = true
    this.formType = this.mode
    this.getCertificates()
    this.fields.push({ key: 'name', tdClass: 'text-center '})
  },
  methods: {
    createCA(){
      let that = this
      if (this.formHasError()) {
        return
      }
      let params = {
        name: this.name,
        certificates: this.listCertificateInGroup.map(elem => elem.id),
      }
      this.$engine.security.ca.create(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.security.ca_added'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/security/0'})
      })
      .catch(e => {
        errorMessageAlert(e, that)
        that.okMessageBox(that.$t('common.security.ca_addition_error'))
      })
    },
    deleteCA() {
      let that = this

      this.$f7.modal({
        title: this.$t('common.security.ca_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = {
                id: that.id
              }
              that.$engine.security.ca.delete(params)
              .then(resp => {
                that.$f7.modal({
                  title: that.$t('common.security.ca_deleted'),
                  buttons: [
                    {
                      text: 'OK',
                      onClick: function () {
                        return
                      }
                    }
                  ]
                })
                loadPage(that, {url: '/security/0'})
              })
              .catch(e => {
                errorMessageAlert(e, that, that.$i18n)
                that.okMessageBox(that.$t('common.security.ca_delete_error'))
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    editCA(){
      let that = this
      let params = {
        name: this.name,
        id: this.id,
        certificates: this.listCertificateInGroup.map(elem => elem.id),
      }
      this.$engine.security.ca.edit(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.security.ca_edited'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/security/0'})
      })
      .catch(e => {
        errorMessageAlert(e, that)
        that.okMessageBox(that.$t('common.security.ca_edit_error'))
      })
    },
    fillFields (CAList){
      this.name = CAList.name
      this.listCertificates.forEach(element => {
        element.inGroup = CAList.Certificates.map(elem => elem.id).includes(element.id)
      })
      this.listCertificates = _.cloneDeep(this.listCertificates)
      this.refreshTab = !this.refreshTab
    },
    formHasError () {
      if (this.name.length === 0) {
        this.okMessageBox(this.$t('common.security.ca_name_missing'))
        return true
      }
      if (this.listCertificateInGroup.length === 0) {
        this.okMessageBox(this.$t('common.security.ca_cert_missing'))
        return true
      }
      return false
    },
    getCA(){
      let that = this
      this.$engine.security.ca.fetch({id: this.id})
      .then(resp => {
        let CAList = {}

        CAList = resp.data.ca

        that.updateCA(CAList)

        this.$f7.pullToRefreshDone()
        that.activateSpinner = false
      })
    },
    getCertificates () {
      let that = this
      this.$engine.security.certificates.fetch()
      .then(resp => {
        let certificatesList = {}

        certificatesList = resp.data.certificates
        that.updateCertificates(certificatesList)
        if(this.id !== '-1' && this.mode === "view"){
          this.getCA()
        }
        this.$f7.pullToRefreshDone()
        that.activateSpinner = false
      })
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    onRowSelectedInGroup (certificates) {
      for (let i = 0; i < this.listCertificateInGroup.length; i++) {
        this.listCertificateInGroup[i].selected = false
      }
      for (let i = 0; i < certificates.length; i++) {
        certificates[i].selected = true
      }
      /* this.selectCertificate(certificates[0]) */
    },
    onRowSelectedOutGroup (certificates) {
      for (let i = 0; i < this.listCertificateOutGroup.length; i++) {
        this.listCertificateOutGroup[i].selected = false
      }
      for (let i = 0; i < certificates.length; i++) {
        certificates[i].selected = true
      }
      /* this.selectCertificate(certificates[0]) */
    },
    putAllCertificate (inGroup) {
      this.listCertificates.forEach(element => {
        element.inGroup = inGroup
        element.selected = false
      })
      this.listCertificates = _.cloneDeep(this.listCertificates)
      this.refreshTab = !this.refreshTab
    },
    putCertificateLeft(){
      this.listCertificates.forEach(element => {
        if (element.inGroup) {
          element.inGroup = !element.selected
          element.selected = false
        }
      })
      this.listCertificates = _.cloneDeep(this.listCertificates)
      this.refreshTab = !this.refreshTab
    },
    putCertificateRight(){
      this.listCertificates.forEach(element => {
        if (!element.inGroup) {
          element.inGroup = element.selected
          element.selected = false
        }
      })
      this.listCertificates = _.cloneDeep(this.listCertificates)
      this.refreshTab = !this.refreshTab
    },
    selectCertificate(certificate){
      if(!this.isEditable){
        return
      }
      certificate.selected = !certificate.selected ? true : false
      this.refreshTab = !this.refreshTab
    },
    switchMode (mode) {
      this.formType = mode
    },
    updateCA(CAList){
      this.currentCA = CAList[0]
      this.fillFields(this.currentCA)
    },
    updateCertificates(certificatesList){
      this.listCertificates = certificatesList
    },
  }
}

</script>
